import { Link } from 'react-router-dom';
import { LogoIcon } from './LogoIcon';
import { LogoText } from './LogoText';

export function NavBarLogo() {
  return (
    <Link to="/" className="logo">
      <LogoIcon size={46} />
      <LogoText fontSize={28} />
    </Link>
  );
}
